import { VouchersTypeEnum } from 'shared/enums/chargeableType'

const isVoucherType = (type: string) =>
  Object.values(VouchersTypeEnum).includes(type)

export default isVoucherType
